import { NavigationPath } from './navigation-path';
import Screens from '@/screens';
import { AuthGuard } from '@/auth/AuthGuard';
import { Route } from '@/router/router-types';
import MainLayout from '@/components/main-layout';
import { Navigate } from 'react-router';
import MeetProviderTest from '@/components/meet-provider-test';

export const privateRoutes: Route[] = [
	{
		element: <AuthGuard />,
		children: [
			{
				element: <MainLayout />,
				children: [
					{
						path: NavigationPath.coachRecurringCalendar,
						element: <Screens.RecurringCalendar />
					},
					{
						path: NavigationPath.coachAppointments,
						element: <Screens.CoachAppointmentsScreen />
					},
					{
						path: NavigationPath.gotItInstantMeetings,
						element: <Screens.GotIt.InstantMeetings />
					},
					{
						path: NavigationPath.gotItPastMeetings,
						element: <Screens.GotIt.PastMeetings />
					},
					{
						path: NavigationPath.coachInstantMeetings,
						element: <Screens.CoachInstantMeetingsScreen />
					},
					{
						path: NavigationPath.coachPastMeetings,
						element: <Screens.CoachPastMeetingsScreen />
					},
					{
						path: NavigationPath.coachPastMeetingsDetail,
						element: <Screens.CoachPastMeetingsDetailV2 />
					},
					{
						path: NavigationPath.coachStudents,
						element: <Screens.CoachStudents />
					},
					{
						path: NavigationPath.coachStudentDetails,
						element: <Screens.CoachStudentDetails />
					},
					{
						path: NavigationPath.gotItPastMeetingsDetail,
						element: <Screens.GotIt.GotItPastMeetingsDetail />
					},
					{
						path: NavigationPath.gotItInstantMeetings,
						element: <Screens.GotIt.InstantMeetings />
					},
					{
						path: NavigationPath.gotItAppointments,
						element: <Screens.GotIt.GotItAppointments />
					},
					{
						path: NavigationPath.gotItRecurringCalendar,
						element: <Screens.GotIt.GotItRecurringCalender />
					},
					{
						path: NavigationPath.gotItStudents,
						element: <Screens.GotIt.GotItStudent />
					},
					{
						path: NavigationPath.gotItStudentDetails,
						element: <Screens.GotIt.GotItStudentDetails />
					},
					{
						path: NavigationPath.gotItPlannedPastMeetings,
						element: <Screens.GotIt.PlannedPastMeetings />
					},
					{
						path: NavigationPath.gotItPlannedAppointments,
						element: <Screens.GotIt.PlannedAppointments />
					},
					{
						path: NavigationPath.gotItPlannedRecurringCalendar,
						element: <Screens.GotIt.PlannedRecurringCalendar />
					},
					{
						path: NavigationPath.profile,
						element: <Screens.Profile />
					},
					{
						path: NavigationPath.messages,
						element: <Screens.Messages />
					},
					{
						path: NavigationPath.notifications,
						element: <Screens.NotificationsScreen />
					},
					{
						path: NavigationPath.solverExpertReview,
						element: <Screens.SolverExpertReviewScreen />
					},
					{
						path: NavigationPath.solverResolveQuestions,
						element: <Screens.SolverResolveQuestionsScreen />
					},
					{
						path: NavigationPath.solverSolve,
						element: <Screens.SolveQuestionScreen />
					},
					{
						path: NavigationPath.solverWhiteBoard,
						element: <Screens.SolverWhiteBoard />
					},
					{
						path: NavigationPath.solverSolvedQuestions,
						element: <Screens.SolverQuestionsAnsweredScreen />
					},
					{
						path: NavigationPath.supportDocuments,
						element: <Screens.SupportDocumentsScreen />
					},
					{
						path: NavigationPath.boutiqueClassroom,
						element: <Screens.BoutiqueClassroomScreen />
					},
					{
						path: NavigationPath.boutiqueStudents,
						element: <Screens.BoutiqueStudentsScreen />
					}
				]
			},
			{
				path: NavigationPath.coachMeetCompleted,
				element: <Screens.CoachMeetCompletedScreen />
			},
			{
				path: NavigationPath.gotItMeetCompleted,
				element: <Screens.GotIt.MeetCompleted />
			},
			{
				path: NavigationPath.applicationReview,
				element: <Screens.ApplicationReviewScreen />
			},
			{
				path: NavigationPath.applicationOnboarding,
				element: <Screens.ApplicationOnboardingScreen />
			},
			{
				path: NavigationPath.meetConnectionTest,
				element: <Screens.MeetConnectionTestScreen />
			},
			{
				path: NavigationPath.meetProviderTest,
				element: <Screens.MeetProviderTest />
			},
			{
				path: '*',
				element: (
					<Navigate
						to={NavigationPath.coachAppointments}
						replace
					/>
				)
			}
		]
	}
];
